import axios from 'axios';
import { ROOT_URL } from '../../../../actions/root_url';

export const createWebUser = (id, payload, success, failed) => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/customer/create_web_account/${id}`,
    data: payload,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    success()
  }, err => {
    alert(JSON.stringify(err.data));
  })
}


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/generalManagement/apis.js